/* eslint-disable max-len */

export const getFooterSectionContent = ({ i18n, hasCreditLine }) => {
  if (!hasCreditLine) {
    return {
      /* i18n-next-line only: ["pt-BR"] */
      title: i18n.jsx.gettext('¿Todavía no activaste la Línea{0}de{0}Crédito de Mercado Pago?', {
        tags: {
          0: '&nbsp;',
        },
      }),
      subtitle: i18n.gettext('Hazlo ahora y comienza a comprar en cuotas sin tarjeta. ¡Es gratis y solo te tomará unos minutos!'),
      cta: {
        text: i18n.jsx.gettext(
          'Activar Línea de Crédito',
          {
            wrapper: 'font',
          },
        ),
      },
    };
  }
  return {
    title: i18n.gettext('Compra ahora y paga después con Cuotas sin Tarjeta'),
    subtitle: i18n.gettext('¡Disfruta lo que te gusta hoy y págalo a tu ritmo!'),
  };
};
